import React from 'react'
import { Link } from '@inertiajs/react'
import { cx } from '@/lib/utils'
import styles from './NavLink.module.scss'

interface NavLinkProps {
  href: string
  children: React.ReactNode
  active?: boolean
}

export const NavLink: React.FC<NavLinkProps> = ({ href, children, active = false }) => (
  <Link href={href} className={cx(styles.link, active && styles.active)}>
    {children}
  </Link>
)
